import {Reeller, ScrollerPlugin} from 'reeller';
import gsap from 'gsap';

Reeller.registerGSAP(gsap);
Reeller.use(ScrollerPlugin);

const initReellers = function() {
    if(document.querySelector('.reeller-container')) {
        // partners reeler
        const logo_reeller = new Reeller({
            container: '.reeller-container',
            wrapper: '.reeller-wrapper',
            itemSelector: '.reeller-item',
            speed: 25,
            initialSeek: 6,
            plugins: {
                scroller: {
                    speed: 1,
                    multiplier: 0.1,
                    threshold: 1,
                    reversed: false,
                },
            },
        });

        // Start Reeler once initialised
        logo_reeller.resume();
    }

    if(document.querySelector('.charities_reeller-container')) {
        // partners reeler
        const logo_reeller = new Reeller({
            container: '.charities_reeller-container',
            wrapper: '.reeller-wrapper',
            itemSelector: '.reeller-item',
            speed: 25,
            initialSeek: 6,
            plugins: {
                scroller: {
                    speed: 1,
                    multiplier: 0.1,
                    threshold: 1,
                    reversed: false,
                },
            },
        });

        // Start Reeler once initialised
        logo_reeller.resume();
    }
}

if (window.acf) {
    // register block to ACF global object
    window.acf.addAction( "render_block_preview/type=reeller-block", initReellers );
} else {
    initReellers();
}